import React, { useEffect } from "react";
import PageTitle from "../../Shared/PageTitle/PageTitle";
import BlogList from "./components/BlogList";
import "./Accesoires.css";

const Accesoires = () => {
  useEffect(() => {
    window.scrollTo(10, 0);
  }, []);

  return (
    <>
      <PageTitle title={"Accesoires"} currentPage={"Accesoires"} />
      <BlogList />
    </>
  );
};

export default Accesoires;
